import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "../../../models";
import { AuthService } from "../../../services";
import { AuthActions, NotificationActions, UserActions } from "../../../store/actions";
import { RequestUtil } from "../../../utils";
import MainAppPresenter from "./MainApp.presenter";
import { C_States, MergedProps } from "./MainApp.type";

class MainAppContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      userData: this.props.Me,
    };
  }

  onLogout = () => {
    this.props.actions.clearAuthData({
      success: () => {
        RequestUtil.removeAuthHeader();
      },
    });
  };

  onSigninSuccess = (input: { token: string; refreshToken: string }) => {
    this.props.actions.cacheAuthData(input, {
      success: () => {
        if (this.props.Auth.data?.token) {
          RequestUtil.setAuthHeader(this.props.Auth.data.token);
          this.props.actions.loadMe();
        }
      },
    });
  };

  onVerifyToken = (token: string) => {
    AuthService.verifyToken(token)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          RequestUtil.setAuthHeader(token);
          this.props.actions.loadMe({
            success: () => {
              this.setState({
                loading: false,
                userData: this.props.Me,
              });
            },
          });
        } else {
          this.props.actions.clearAuthData({
            success: () => {
              this.setState({ loading: false });
            },
          });
        }
      })
      .catch((err) => {
        this.props.actions.clearAuthData({
          success: () => {
            this.setState({ loading: false });
          },
        });
      });
  };

  render() {
    return (
      <MainAppPresenter
        {...this.props}
        {...this.state}
        onSigninSuccess={this.onSigninSuccess}
        onLogout={this.onLogout}
      />
    );
  }

  componentDidMount() {
    if (!this.props.Auth.data?.token) {
      this.setState({ loading: false });
    } else {
      this.onVerifyToken(this.props.Auth.data.token);
    }
  }
}

export default connect(
  (state: RootState) => ({
    Me: state.me,
    Auth: state.auth,
  }),
  (dispatch: Dispatch) => ({
    actions: bindActionCreators(Object.assign({}, NotificationActions, AuthActions, UserActions), dispatch),
  }),
)(MainAppContainer);
